// extracted by mini-css-extract-plugin
export default {"root":"wfyzg6tIPIkHHxHeLBKb","wrap":"A8hPgb1HyTVa3tBVet5A","title":"OFPfID1xS9JTptd5i6k0","text":"dk8TyvvTBtWNtYAATfvq"};